module.exports = __webpack_public_path__ + "img/wordCup.2f2dfe3a.png";